import { combineReducers } from 'redux';

import card from './card';
import session from './session';
import activation from './activation';
import link from './link';
import payments from './payments';
import transactions from './transactions';

export default combineReducers({
  card,
  session,
  activation,
  link,
  payments,
  transactions
});
